module.exports = __webpack_public_path__ + "static/img/banner_icon_02.63b8a22.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/banner_icon_02.png
// module id = dSRG
// module chunks = 0